export default [
    {
    id: "03601",
    name: "Terrace Eye Institute",
},
{
    id: "03602",
    name: "Centre for Eye Research Australia",
} ];